import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import bandeau from '../img/bandeau.jpg';

const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={bandeau} 
          alt="Ninsun Biotech Background" 
          className="w-full h-full object-cover object-center opacity-60"
        />
        <div className="absolute inset-0 bg-white/60 backdrop-blur-sm"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h1 
            className="text-5xl md:text-6xl lg:text-7xl xl:text-[5.5rem] xl:whitespace-nowrap font-display font-bold mb-6 text-ninsun-text leading-[1.1] tracking-tight"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            Predicting <span className="text-ninsun-gold">Immunotherapy</span> Response
          </motion.h1>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="flex items-center justify-center gap-3 mb-8"
          >
            <span className="font-mono text-ninsun-gold text-base md:text-lg tracking-widest uppercase font-bold">
              We provide the missing piece for optimal treatment decision-making in oncology
            </span>
          </motion.div>

          <motion.div 
            className="text-lg md:text-xl text-ninsun-muted mb-12 max-w-3xl mx-auto font-sans font-light leading-relaxed space-y-4"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="font-bold text-ninsun-text">
              We are developing the missing piece in immunotherapy decision-making for NSCLC:
              <br />
              identify patients most likely to achieve complete response to treatment.
            </p>
            <p>
              Despite the transformative impact of immune checkpoint inhibitors, up to 80% of patients do not respond, resulting in avoidable toxicity, delayed access to effective therapies, and significant healthcare costs.
            </p>
            <p>
              By enabling more accurate patient stratification, we aim to improve treatment selection, clinical outcomes, and healthcare efficiency.
            </p>
          </motion.div>

          <motion.div
            className="glass-panel rounded-2xl p-8 md:p-10 mb-12 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.25 }}
          >
            <h2 className="text-2xl md:text-3xl font-display font-bold text-ninsun-text mb-4 tracking-tight">Our Mission</h2>
            <p className="text-ninsun-muted leading-relaxed">
              Support optimal treatment decision-making by providing actionable insights into cancer stem cells burden within the tumor microenvironment, a key driver of resistance to immunotherapy.
            </p>
          </motion.div>

          <motion.div
            className="flex justify-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <Link
              to="/contact"
              className="glass-panel text-ninsun-text px-8 py-4 font-mono font-bold text-sm tracking-wide hover:bg-gray-50 transition-colors flex items-center justify-center rounded-md"
            >
              CONTACT US
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;